<ui-input-wrapper
  [label]="base.label"
  [help]="base.help"
  [helpTooltipPosition]="base.helpTooltipPosition()"
  [errorLabels]="base.errorLabels()"
  [labelTemplate]="base.labelTemplate"
  [hintTemplate]="base.hintTemplate"
  [hint]="base.hint"
  [errors]="control.errors"
  [submitted]="submitted"
  [control]="control"
  [labelTemplate]="base.labelTemplate">
  <input
    pInputText
    class="__input"
    #nativeInputElement
    [formControl]="$any(control)"
    type="number"
    (input)="emitNumberValueChange($any($event.currentTarget).value)"
    [style.paddingRight]="paddingRight"
    [readonly]="base.readonly()"
    [attr.max]="number.max()"
    [attr.step]="number.step()"
    (keypress)="validateNumber($event)"
    (paste)="trimValuePaste($event)"
    [attr.min]="number.min()"
    [attr.placeholder]="base.placeholder ? base.placeholder : base.label"
    [attr.name]="base.name()" />
  @if (text.appendText || dropdown.clearable) {
    <span class="absolute top-0 right-4 flex h-10 items-center">
      @if (dropdown.clearable && nativeInputElement.value.length) {
        <span matTooltip="Vymazat obsah pole" (click)="control.reset(); dropdown.clear.emit()" class="__clear-input">
        </span>
      }
      @if (text.appendText) {
        <span class="__append-text" [innerHTML]="text.appendText"> </span>
      }
    </span>
  }
</ui-input-wrapper>
